/**
 * Copyright (C) IRT GmbH 2020
 */

var Logger = function (global) {
	var debug = null;
	var maxLines = 40;
	var enabled = false;

	function init () {
		debug = document.getElementById("debug");
	}
	function append (text) {
		if (enabled && text) {
			if (debug === null) init();

			var lines =	debug.innerHTML.split(/<br[^\>]*>/);
			lines.unshift(new Date().toLocaleTimeString() + " - " + text);

			if (lines.length > maxLines) {
				lines = lines.splice(0, maxLines - 1);
			}
			debug.innerHTML = lines.join("<br />");
		}
	}
	function enable (b) {
		enabled = b;
	}

	function toggle () {
		if (debug === null) init();
		debug.classList.toggle("hidden");
	}

	return {
		init: init,
		enable : enable,
		toggle  : toggle,
		append : append,
		error  : function (err) {append(err, true);}
	};
}();

module.exports = Logger;
